import React from 'react';
import './Awards.css';

// Import all your award logos
import award1 from '../../assets/images/award-logo-1.png';
import award2 from '../../assets/images/award-logo-2.png';
import award3 from '../../assets/images/award-logo-3.png';
import award4 from '../../assets/images/award-logo-4.png';
import award5 from '../../assets/images/award-logo-5.png';
// Create an array with all the award logos
const awardsList = [
  { src: award1, alt: 'Award 1' },
  { src: award2, alt: 'Award 2' },
  { src: award3, alt: 'Award 3' },
  { src: award4, alt: 'Award 4' },
  { src: award5, alt: 'Award 5' },
];

// For the seamless scroll, we duplicate the array
const duplicatedAwards = [...awardsList, ...awardsList];

const Awards = () => {
  return (
    <section className="awards-section">
      <div className="section-header">
        <h2>Awards</h2>
        <div className="header-line"></div>
      </div>
      <p className="section-subtitle">
        Recognized for innovation and impact, and trusted by industry partners across various sectors.
      </p>

      <div className="awards-scroller-wrap">
        <div className="awards-scroller-content">
          {duplicatedAwards.map((award, index) => (
            <div key={index} className="award-card">
              <img src={award.src} alt={award.alt} className="award-logo" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Awards;